import Layout from '../../components/Layout.jsx'
import { DataTable } from '../../components/DataTable.jsx'
import { useApp } from '../../context/AppContext.jsx'
import { getLandingPages } from '../../db/api.js'
import { useApiData } from '../../hooks/useApiData.js'

function shortUrl(value) {
  if (!value) return '-'
  return value.length > 70 ? `${value.slice(0, 69)}...` : value
}

export default function LandingPages() {
  const { period } = useApp()
  const { data, loading, error } = useApiData(
    () => getLandingPages(period.start, period.end),
    [period.start, period.end],
    { initialData: [] }
  )

  const columns = [
    { key: 'url', label: 'Landing page', width: 320, render: (value) => shortUrl(value) },
    { key: 'campaignName', label: 'Campanha', width: 220 },
    { key: 'adGroupName', label: 'Grupo', width: 220 },
    { key: 'impressions', label: 'Impressoes', format: 'number', align: 'right', width: 120 },
    { key: 'clicks', label: 'Cliques', format: 'number', align: 'right', width: 100 },
    { key: 'ctr', label: 'CTR', format: 'percent', align: 'right', width: 90 },
    { key: 'averageCpc', label: 'CPC medio', format: 'currency', align: 'right', width: 130 },
    { key: 'cost', label: 'Investimento', format: 'currency', align: 'right', width: 150 },
  ]

  return (
    <Layout
      breadcrumb={[{ label: 'Analytics' }, { label: 'Landing pages' }]}
      title="Landing Pages"
      showPeriod
    >
      <div className="section-card">
        <div className="sc-head">
          <div className="card-title-group">
            <span className="t-label">Destino</span>
            <span className="t-title" style={{ fontSize: 17 }}>URLs finais dos anuncios</span>
          </div>
        </div>
        <div style={{ padding: '0 24px 24px' }}>
          {error ? (
            <div className="empty" style={{ padding: 32 }}>
              <div className="empty-title">Nao foi possivel carregar as landing pages</div>
              <div className="empty-desc">{error}</div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data || []}
              loading={loading}
              emptyText="Nenhuma landing page encontrada"
              pagination
              pageSize={15}
              striped={false}
            />
          )}
        </div>
      </div>
    </Layout>
  )
}
